<template>
    <div>
      <nuxt/>
    </div>
</template>

<script>
import {ding_erformance} from "./js/entConsoleDate.js"
    export default {
        name: "initPage",
        mounted() {
            ding_erformance()
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// layouts/initPage.vue